<template>
  <section id="mainContent">
     <general-header :headerTitle="'Registro de ponto'" :headerIcon="['finger-print-outline']"></general-header>

    <left-menu></left-menu>

    <!-- <div class="print-background-wrapper"> -->
      <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 803 862" fill="none" id="first-bg">
        <path d="M451.664 41.2103C448.748 42.9041 445.43 43.7841 442.057 43.7585C351.316 46.6679 282.298 65.5242 210.452 107.004C138.966 148.277 81.2593 205.084 39.8622 275.966C33.9809 285.942 21.2359 288.719 10.9454 282.582C6.16229 279.513 2.72662 274.739 1.33637 269.23C-0.0538882 263.72 0.705546 257.887 3.46038 252.917C48.244 176.706 112.13 113.493 188.811 69.5196C265.701 25.1269 343.033 3.96986 439.414 0.802665C445.075 0.684433 450.558 2.79 454.685 6.6676C458.812 10.5452 461.254 15.8859 461.489 21.5439C461.903 25.4182 461.197 29.3298 459.456 32.8154C457.715 36.301 455.011 39.2143 451.664 41.2103ZM48.636 536.291C44.8693 538.43 40.5367 539.362 36.2238 538.959C30.5334 538.299 25.3215 535.456 21.6857 531.029C18.0499 526.602 16.2742 520.937 16.7326 515.227C22.1851 442.108 43.8449 374.625 81.3616 314.48C159.698 188.369 304.589 104.133 453.368 99.2027C524.197 96.7935 593.268 111.393 659.101 142.856C664.266 145.324 668.275 149.696 670.29 155.054C672.304 160.412 672.168 166.342 669.908 171.602C668.813 174.155 667.205 176.456 665.184 178.363C663.164 180.27 660.774 181.741 658.161 182.687C655.549 183.633 652.771 184.033 649.998 183.862C647.225 183.692 644.517 182.954 642.04 181.694C582.285 153.22 519.705 139.871 456.026 142.15C320.599 146.869 188.091 223.372 116.866 338.464C82.9105 393.053 63.3973 454.299 58.1431 520.223C58.1753 523.514 57.3064 526.751 55.6306 529.583C53.9547 532.416 51.5359 534.735 48.636 536.291ZM535.53 858.519C533.157 859.919 530.511 860.793 527.771 861.082C525.031 861.371 522.261 861.067 519.648 860.191C469.375 845.651 440.195 834.426 389.914 803.064C338.305 771.386 292.926 722.616 258.082 662.266C193.806 550.937 233.13 407.283 345.787 342.24C458.444 277.198 602.576 314.933 666.852 426.263C668.318 428.636 669.291 431.28 669.716 434.037C670.141 436.794 670.009 439.608 669.327 442.312C668.644 445.017 667.426 447.557 665.745 449.783C664.063 452.008 661.952 453.874 659.536 455.268C657.12 456.663 654.449 457.559 651.681 457.903C648.913 458.246 646.104 458.031 643.42 457.27C640.737 456.508 638.233 455.216 636.058 453.469C633.883 451.723 632.081 449.558 630.758 447.102C578.385 356.389 460.281 326.116 367.507 379.68C274.732 433.243 241.819 550.705 294.193 641.418C325.357 695.396 365.682 738.586 411.078 766.355C459.081 796.117 485.617 805.287 530.252 818.501C535.644 820.239 540.198 823.918 543.03 828.824C545.863 833.73 546.772 839.514 545.581 845.052C544.102 850.674 540.498 855.502 535.53 858.519ZM754.371 639.709C711.404 664.516 667.005 675.156 623.187 670.966C586.028 667.697 550.199 655.548 518.716 635.542C487.233 615.535 461.018 588.257 442.277 556.004C440.771 553.629 439.76 550.973 439.306 548.196C438.852 545.42 438.964 542.581 439.636 539.849C440.307 537.117 441.524 534.549 443.213 532.299C444.903 530.05 447.029 528.165 449.466 526.758C451.902 525.352 454.598 524.452 457.39 524.114C460.183 523.776 463.016 524.006 465.717 524.79C468.419 525.575 470.934 526.898 473.111 528.679C475.289 530.46 477.083 532.663 478.388 535.156C493.598 561.361 514.914 583.502 540.522 599.697C566.13 615.891 595.271 625.658 625.466 628.167C661.484 631.362 696.398 622.617 732.508 601.769C744.955 594.284 756.768 585.793 767.828 576.379C776.492 568.878 789.775 570.205 797.63 579.664C801.342 583.979 803.191 589.591 802.771 595.267C802.352 600.944 799.698 606.222 795.392 609.945C782.651 621.089 768.907 631.032 754.335 639.646L754.371 639.709ZM726.337 758.769C724.714 759.618 722.996 760.274 721.219 760.724C654.283 777.379 603.967 776.941 541.451 759.556C460.812 736.642 392.989 683.337 350.138 609.118C315.079 548.392 336.335 470.147 397.7 434.718C459.066 399.288 537.472 419.994 572.532 480.719C595.688 520.827 648.097 534.051 689.611 510.083C731.125 486.115 745.877 434.116 722.72 394.007C641.131 252.69 457.564 205.735 313.155 289.11C210.619 348.309 150.945 461.73 161.734 577.95C165.208 616.428 178.52 656.223 201.028 695.207C217.908 724.445 247.042 769.099 303.332 816.567C312.582 824.221 314.157 837.806 306.718 846.599C304.978 848.737 302.824 850.5 300.384 851.784C297.945 853.068 295.272 853.845 292.525 854.07C289.777 854.294 287.013 853.961 284.398 853.091C281.783 852.22 279.37 850.829 277.306 849.003C232.444 811.53 194.524 766.458 165.277 715.847C139.307 670.866 123.99 625.148 119.71 580.222C107.32 447.849 174.688 318.574 291.297 251.251C455.573 156.405 665.121 210.851 758.614 372.784C793.674 433.509 772.417 511.755 711.036 547.193C649.655 582.631 571.265 561.917 536.205 501.192C513.064 461.075 460.62 447.788 419.105 471.756C377.591 495.724 362.839 547.723 385.996 587.832C422.967 651.868 481.464 698.146 551.12 717.905C605.824 733.303 649.841 733.796 709.218 719.089C720.479 716.087 731.958 723.453 735.055 734.66C736.551 739.072 736.503 743.86 734.919 748.241C733.335 752.622 730.309 756.334 726.337 758.769Z" fill="#1B59F8" fill-opacity="0.02"/>
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 803 862" fill="none" id="second-bg">
        <path d="M451.664 41.2103C448.748 42.9041 445.43 43.7841 442.057 43.7585C351.316 46.6679 282.298 65.5242 210.452 107.004C138.966 148.277 81.2593 205.084 39.8622 275.966C33.9809 285.942 21.2359 288.719 10.9454 282.582C6.16229 279.513 2.72662 274.739 1.33637 269.23C-0.0538882 263.72 0.705546 257.887 3.46038 252.917C48.244 176.706 112.13 113.493 188.811 69.5196C265.701 25.1269 343.033 3.96986 439.414 0.802665C445.075 0.684433 450.558 2.79 454.685 6.6676C458.812 10.5452 461.254 15.8859 461.489 21.5439C461.903 25.4182 461.197 29.3298 459.456 32.8154C457.715 36.301 455.011 39.2143 451.664 41.2103ZM48.636 536.291C44.8693 538.43 40.5367 539.362 36.2238 538.959C30.5334 538.299 25.3215 535.456 21.6857 531.029C18.0499 526.602 16.2742 520.937 16.7326 515.227C22.1851 442.108 43.8449 374.625 81.3616 314.48C159.698 188.369 304.589 104.133 453.368 99.2027C524.197 96.7935 593.268 111.393 659.101 142.856C664.266 145.324 668.275 149.696 670.29 155.054C672.304 160.412 672.168 166.342 669.908 171.602C668.813 174.155 667.205 176.456 665.184 178.363C663.164 180.27 660.774 181.741 658.161 182.687C655.549 183.633 652.771 184.033 649.998 183.862C647.225 183.692 644.517 182.954 642.04 181.694C582.285 153.22 519.705 139.871 456.026 142.15C320.599 146.869 188.091 223.372 116.866 338.464C82.9105 393.053 63.3973 454.299 58.1431 520.223C58.1753 523.514 57.3064 526.751 55.6306 529.583C53.9547 532.416 51.5359 534.735 48.636 536.291ZM535.53 858.519C533.157 859.919 530.511 860.793 527.771 861.082C525.031 861.371 522.261 861.067 519.648 860.191C469.375 845.651 440.195 834.426 389.914 803.064C338.305 771.386 292.926 722.616 258.082 662.266C193.806 550.937 233.13 407.283 345.787 342.24C458.444 277.198 602.576 314.933 666.852 426.263C668.318 428.636 669.291 431.28 669.716 434.037C670.141 436.794 670.009 439.608 669.327 442.312C668.644 445.017 667.426 447.557 665.745 449.783C664.063 452.008 661.952 453.874 659.536 455.268C657.12 456.663 654.449 457.559 651.681 457.903C648.913 458.246 646.104 458.031 643.42 457.27C640.737 456.508 638.233 455.216 636.058 453.469C633.883 451.723 632.081 449.558 630.758 447.102C578.385 356.389 460.281 326.116 367.507 379.68C274.732 433.243 241.819 550.705 294.193 641.418C325.357 695.396 365.682 738.586 411.078 766.355C459.081 796.117 485.617 805.287 530.252 818.501C535.644 820.239 540.198 823.918 543.03 828.824C545.863 833.73 546.772 839.514 545.581 845.052C544.102 850.674 540.498 855.502 535.53 858.519ZM754.371 639.709C711.404 664.516 667.005 675.156 623.187 670.966C586.028 667.697 550.199 655.548 518.716 635.542C487.233 615.535 461.018 588.257 442.277 556.004C440.771 553.629 439.76 550.973 439.306 548.196C438.852 545.42 438.964 542.581 439.636 539.849C440.307 537.117 441.524 534.549 443.213 532.299C444.903 530.05 447.029 528.165 449.466 526.758C451.902 525.352 454.598 524.452 457.39 524.114C460.183 523.776 463.016 524.006 465.717 524.79C468.419 525.575 470.934 526.898 473.111 528.679C475.289 530.46 477.083 532.663 478.388 535.156C493.598 561.361 514.914 583.502 540.522 599.697C566.13 615.891 595.271 625.658 625.466 628.167C661.484 631.362 696.398 622.617 732.508 601.769C744.955 594.284 756.768 585.793 767.828 576.379C776.492 568.878 789.775 570.205 797.63 579.664C801.342 583.979 803.191 589.591 802.771 595.267C802.352 600.944 799.698 606.222 795.392 609.945C782.651 621.089 768.907 631.032 754.335 639.646L754.371 639.709ZM726.337 758.769C724.714 759.618 722.996 760.274 721.219 760.724C654.283 777.379 603.967 776.941 541.451 759.556C460.812 736.642 392.989 683.337 350.138 609.118C315.079 548.392 336.335 470.147 397.7 434.718C459.066 399.288 537.472 419.994 572.532 480.719C595.688 520.827 648.097 534.051 689.611 510.083C731.125 486.115 745.877 434.116 722.72 394.007C641.131 252.69 457.564 205.735 313.155 289.11C210.619 348.309 150.945 461.73 161.734 577.95C165.208 616.428 178.52 656.223 201.028 695.207C217.908 724.445 247.042 769.099 303.332 816.567C312.582 824.221 314.157 837.806 306.718 846.599C304.978 848.737 302.824 850.5 300.384 851.784C297.945 853.068 295.272 853.845 292.525 854.07C289.777 854.294 287.013 853.961 284.398 853.091C281.783 852.22 279.37 850.829 277.306 849.003C232.444 811.53 194.524 766.458 165.277 715.847C139.307 670.866 123.99 625.148 119.71 580.222C107.32 447.849 174.688 318.574 291.297 251.251C455.573 156.405 665.121 210.851 758.614 372.784C793.674 433.509 772.417 511.755 711.036 547.193C649.655 582.631 571.265 561.917 536.205 501.192C513.064 461.075 460.62 447.788 419.105 471.756C377.591 495.724 362.839 547.723 385.996 587.832C422.967 651.868 481.464 698.146 551.12 717.905C605.824 733.303 649.841 733.796 709.218 719.089C720.479 716.087 731.958 723.453 735.055 734.66C736.551 739.072 736.503 743.86 734.919 748.241C733.335 752.622 730.309 756.334 726.337 758.769Z" fill="#1B59F8" fill-opacity="0.02"/>
      </svg> -->

      <!-- <svg xmlns="http://www.w3.org/2000/svg" width="803" height="862" viewBox="0 0 803 862" fill="none" id="third-bg">
        <path d="M451.664 41.2103C448.748 42.9041 445.43 43.7841 442.057 43.7585C351.316 46.6679 282.298 65.5242 210.452 107.004C138.966 148.277 81.2593 205.084 39.8622 275.966C33.9809 285.942 21.2359 288.719 10.9454 282.582C6.16229 279.513 2.72662 274.739 1.33637 269.23C-0.0538882 263.72 0.705546 257.887 3.46038 252.917C48.244 176.706 112.13 113.493 188.811 69.5196C265.701 25.1269 343.033 3.96986 439.414 0.802665C445.075 0.684433 450.558 2.79 454.685 6.6676C458.812 10.5452 461.254 15.8859 461.489 21.5439C461.903 25.4182 461.197 29.3298 459.456 32.8154C457.715 36.301 455.011 39.2143 451.664 41.2103ZM48.636 536.291C44.8693 538.43 40.5367 539.362 36.2238 538.959C30.5334 538.299 25.3215 535.456 21.6857 531.029C18.0499 526.602 16.2742 520.937 16.7326 515.227C22.1851 442.108 43.8449 374.625 81.3616 314.48C159.698 188.369 304.589 104.133 453.368 99.2027C524.197 96.7935 593.268 111.393 659.101 142.856C664.266 145.324 668.275 149.696 670.29 155.054C672.304 160.412 672.168 166.342 669.908 171.602C668.813 174.155 667.205 176.456 665.184 178.363C663.164 180.27 660.774 181.741 658.161 182.687C655.549 183.633 652.771 184.033 649.998 183.862C647.225 183.692 644.517 182.954 642.04 181.694C582.285 153.22 519.705 139.871 456.026 142.15C320.599 146.869 188.091 223.372 116.866 338.464C82.9105 393.053 63.3973 454.299 58.1431 520.223C58.1753 523.514 57.3064 526.751 55.6306 529.583C53.9547 532.416 51.5359 534.735 48.636 536.291ZM535.53 858.519C533.157 859.919 530.511 860.793 527.771 861.082C525.031 861.371 522.261 861.067 519.648 860.191C469.375 845.651 440.195 834.426 389.914 803.064C338.305 771.386 292.926 722.616 258.082 662.266C193.806 550.937 233.13 407.283 345.787 342.24C458.444 277.198 602.576 314.933 666.852 426.263C668.318 428.636 669.291 431.28 669.716 434.037C670.141 436.794 670.009 439.608 669.327 442.312C668.644 445.017 667.426 447.557 665.745 449.783C664.063 452.008 661.952 453.874 659.536 455.268C657.12 456.663 654.449 457.559 651.681 457.903C648.913 458.246 646.104 458.031 643.42 457.27C640.737 456.508 638.233 455.216 636.058 453.469C633.883 451.723 632.081 449.558 630.758 447.102C578.385 356.389 460.281 326.116 367.507 379.68C274.732 433.243 241.819 550.705 294.193 641.418C325.357 695.396 365.682 738.586 411.078 766.355C459.081 796.117 485.617 805.287 530.252 818.501C535.644 820.239 540.198 823.918 543.03 828.824C545.863 833.73 546.772 839.514 545.581 845.052C544.102 850.674 540.498 855.502 535.53 858.519ZM754.371 639.709C711.404 664.516 667.005 675.156 623.187 670.966C586.028 667.697 550.199 655.548 518.716 635.542C487.233 615.535 461.018 588.257 442.277 556.004C440.771 553.629 439.76 550.973 439.306 548.196C438.852 545.42 438.964 542.581 439.636 539.849C440.307 537.117 441.524 534.549 443.213 532.299C444.903 530.05 447.029 528.165 449.466 526.758C451.902 525.352 454.598 524.452 457.39 524.114C460.183 523.776 463.016 524.006 465.717 524.79C468.419 525.575 470.934 526.898 473.111 528.679C475.289 530.46 477.083 532.663 478.388 535.156C493.598 561.361 514.914 583.502 540.522 599.697C566.13 615.891 595.271 625.658 625.466 628.167C661.484 631.362 696.398 622.617 732.508 601.769C744.955 594.284 756.768 585.793 767.828 576.379C776.492 568.878 789.775 570.205 797.63 579.664C801.342 583.979 803.191 589.591 802.771 595.267C802.352 600.944 799.698 606.222 795.392 609.945C782.651 621.089 768.907 631.032 754.335 639.646L754.371 639.709ZM726.337 758.769C724.714 759.618 722.996 760.274 721.219 760.724C654.283 777.379 603.967 776.941 541.451 759.556C460.812 736.642 392.989 683.337 350.138 609.118C315.079 548.392 336.335 470.147 397.7 434.718C459.066 399.288 537.472 419.994 572.532 480.719C595.688 520.827 648.097 534.051 689.611 510.083C731.125 486.115 745.877 434.116 722.72 394.007C641.131 252.69 457.564 205.735 313.155 289.11C210.619 348.309 150.945 461.73 161.734 577.95C165.208 616.428 178.52 656.223 201.028 695.207C217.908 724.445 247.042 769.099 303.332 816.567C312.582 824.221 314.157 837.806 306.718 846.599C304.978 848.737 302.824 850.5 300.384 851.784C297.945 853.068 295.272 853.845 292.525 854.07C289.777 854.294 287.013 853.961 284.398 853.091C281.783 852.22 279.37 850.829 277.306 849.003C232.444 811.53 194.524 766.458 165.277 715.847C139.307 670.866 123.99 625.148 119.71 580.222C107.32 447.849 174.688 318.574 291.297 251.251C455.573 156.405 665.121 210.851 758.614 372.784C793.674 433.509 772.417 511.755 711.036 547.193C649.655 582.631 571.265 561.917 536.205 501.192C513.064 461.075 460.62 447.788 419.105 471.756C377.591 495.724 362.839 547.723 385.996 587.832C422.967 651.868 481.464 698.146 551.12 717.905C605.824 733.303 649.841 733.796 709.218 719.089C720.479 716.087 731.958 723.453 735.055 734.66C736.551 739.072 736.503 743.86 734.919 748.241C733.335 752.622 730.309 756.334 726.337 758.769Z" fill="#1B59F8" fill-opacity="0.02"/>
      </svg> -->

    <!-- </div> -->

    <div class="confirm-point-wrapper">
      <div class="wrapper-confirm"></div>
      <shadow-box class="confirm-point">
        <ion-icon name="checkmark-circle-outline"></ion-icon>
        <span id="confirm-point-date">Registro confirmado em {{dataPointRegister.dataConfirm.date | formatDate}} às {{dataPointRegister.dataConfirm.date | formatHours}}</span>
        <span>(Horário oficial central)</span>

        <svg xmlns="http://www.w3.org/2000/svg" width="355" height="2" viewBox="0 0 355 2" fill="none">
          <path d="M0 1L355 1.00003" stroke="#E2E2E2"/>
        </svg>

        <button @click="openModalVoucher"
        :disabled="loadingVoucher"
        :class="{'register-loader': loadingVoucher}">
          <dot-loader v-if="loadingVoucher" id="voucher-loader"></dot-loader>
          <div class="open-voucher-wrapper" v-else>
            <ion-icon  name="receipt-outline"></ion-icon>
            <span>Ver comprovante</span>
          </div>

        </button>
        <span>Para ver o comprovante novamente, navegue até os detalhes deste dia.</span>

      </shadow-box>

      <button class="return-home-button" @click="redirectToHome">
        <ion-icon name="home-outline"></ion-icon>
        Voltar ao início
      </button>
    </div>



    <confirmation-modal
      v-if="isVoucherModalOpened && !loadingVoucher"
      :title="'Comprovante do dia'"
      :titleIcon="['receipt-outline']"
      :canClose="true"
      @close-modal="v => this.isVoucherModalOpened = v"
      id="voucher-modal"
    >
      <div class="voucher-modal-body">

        <div class="voucher-header">
          <span>Seu comprovante</span>
          <span>Está em processamento!</span>
        </div>

        <div class="body-content">
            <ion-icon name="hourglass-outline"></ion-icon>

            <span>Tente visualizar</span>
            <span>novamente mais tarde...</span>

          <div class="footer-body">
            <svg width="327" height="16" viewBox="0 0 327 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.5" d="M8.86445 16L-4.34089e-06 1.29135e-06L17.7289 2.86102e-06L8.86445 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M27.0858 16L17.7289 1.21428e-06L36.4428 2.86102e-06L27.0858 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M45.7997 16L36.4428 1.21428e-06L55.1566 2.86102e-06L45.7997 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M64.5136 16L55.1566 1.21428e-06L73.8705 2.86102e-06L64.5136 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M82.7349 16L73.8705 1.30095e-06L91.5994 2.86102e-06L82.7349 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M100.464 16L91.5994 1.30095e-06L109.328 2.86102e-06L100.464 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M118.193 16L109.328 1.29135e-06L127.057 2.86102e-06L118.193 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M135.922 16L127.057 1.29135e-06L144.786 2.86102e-06L135.922 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M154.143 16L144.786 1.21428e-06L163.5 2.86102e-06L154.143 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M172.857 16L163.5 1.21428e-06L182.214 2.86102e-06L172.857 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M191.078 16L182.214 1.30095e-06L199.943 2.86102e-06L191.078 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M208.807 16L199.943 1.30095e-06L217.672 2.86102e-06L208.807 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M226.536 16L217.672 1.30095e-06L235.401 2.86102e-06L226.536 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M244.265 16L235.401 1.30095e-06L253.13 2.86102e-06L244.265 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M262.486 16L253.13 1.21428e-06L271.843 2.86102e-06L262.486 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M281.2 16L271.843 1.21428e-06L290.557 2.86102e-06L281.2 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M299.914 16L290.557 1.21428e-06L309.271 2.86102e-06L299.914 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M318.136 16L309.271 1.30095e-06L327 2.86102e-06L318.136 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M9.13591 16L0.27145 1.30095e-06L18.0004 2.86102e-06L9.13591 16Z" fill="#FFE268"/>
            </svg>
          </div>
        </div>

        <!-- <div class="voucher-header">
          Comprovante de ponto do dia
          <span class="header-date">
            {{ dataCodeVaucher.data.pointReference | formatDate }}
          </span>
          <span>{{ dataCodeVaucher.data.company.representationName }}</span>
          <span>CNPJ: {{ dataCodeVaucher.data.company.document | cpfOrCnpj }}</span>
          <span>Registro INPI: {{ dataCodeVaucher.data.inpiRegister }}</span>
        </div> -->

        <!-- <div class="body-content">
          <div v-for="data, index in dataCodeVaucher.data.days" v-bind:key="index" class="content-points">
            <div class="point-title">Ponto {{index+1}}: <span>{{ data.data.day }} às {{ data.data.hour }}</span></div>
            <span>Local: {{ data.data.local }}</span>

            <span class="point-code" :style="data.viewMore ? 'display: block;' : 'display: flex;'">Código: <span :class="!data.viewMore ? 'hide-code' : ''">{{ data.asignHashPoint}}</span>
              <span v-if="data.viewMore" class="more-less" @click="viewMoreLess(data)">Ver menos</span>
              <span v-else class="more-less" @click="viewMoreLess(data)">Ver Mais</span>
            </span>
          </div>
        </div>
        <div class="body-collaborator">
          <span class="collaborator-name">Colaborador: <span>{{ dataCodeVaucher.data.employee.name }}</span></span>
          <span>({{ dataCodeVaucher.data.employee.cpf }})</span>
        </div>
        <div class="body-signature">
          <span class="signature-title">Assinatura eltrônica:</span>
          <span class="signature-id" :style="!viewMoreSign ? 'display: flex;' : 'display: block;'">
            <span :class="!viewMoreSign ? 'hide-code' : ''">{{ dataCodeVaucher.asignHash }}</span>
            <span class="more-less" @click="viewMoreLessSign(!viewMoreSign)">{{ viewMoreSign ? 'Ver Menos' : 'Ver Mais' }}</span>
          </span>
          <span class="signature-reference">Referência: <span>{{ dataCodeVaucher.data.employee.reference }}</span></span>
        </div>
        <div class="footer-body">
          <svg width="327" height="16" viewBox="0 0 327 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.5" d="M8.86445 16L-4.34089e-06 1.29135e-06L17.7289 2.86102e-06L8.86445 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M27.0858 16L17.7289 1.21428e-06L36.4428 2.86102e-06L27.0858 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M45.7997 16L36.4428 1.21428e-06L55.1566 2.86102e-06L45.7997 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M64.5136 16L55.1566 1.21428e-06L73.8705 2.86102e-06L64.5136 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M82.7349 16L73.8705 1.30095e-06L91.5994 2.86102e-06L82.7349 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M100.464 16L91.5994 1.30095e-06L109.328 2.86102e-06L100.464 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M118.193 16L109.328 1.29135e-06L127.057 2.86102e-06L118.193 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M135.922 16L127.057 1.29135e-06L144.786 2.86102e-06L135.922 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M154.143 16L144.786 1.21428e-06L163.5 2.86102e-06L154.143 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M172.857 16L163.5 1.21428e-06L182.214 2.86102e-06L172.857 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M191.078 16L182.214 1.30095e-06L199.943 2.86102e-06L191.078 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M208.807 16L199.943 1.30095e-06L217.672 2.86102e-06L208.807 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M226.536 16L217.672 1.30095e-06L235.401 2.86102e-06L226.536 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M244.265 16L235.401 1.30095e-06L253.13 2.86102e-06L244.265 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M262.486 16L253.13 1.21428e-06L271.843 2.86102e-06L262.486 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M281.2 16L271.843 1.21428e-06L290.557 2.86102e-06L281.2 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M299.914 16L290.557 1.21428e-06L309.271 2.86102e-06L299.914 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M318.136 16L309.271 1.30095e-06L327 2.86102e-06L318.136 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M9.13591 16L0.27145 1.30095e-06L18.0004 2.86102e-06L9.13591 16Z" fill="#FFE268"/>
          </svg>
        </div> -->
      </div>

      <!-- <div v-if="sendEmailDisplay" class="body-email">
        <div class="email-input">
          <label>
            Enviar para o e-mail <span>*</span>
          </label>
          <input v-model="valueEmail" type="text" placeholder="Digite o seu E-mail">
          <span v-if="validateInputEmail" class="validate-input">
            Parece que esse é um e-mail inválido, digite outro e-mail e tente novamente.
          </span>
        </div>
        <div class="email-btn">
          <span @click="statusEmail(false)" class="btn-cancel">Cancelar</span>
          <button @click="sendEmail()" class="btn-send" :disabled="loadingEmail">
            <div v-if="loadingEmail" class="loading-btn">
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5">
                </div>
              </div>
            </div>
            <div v-else class="btn-group">
              Enviar
            </div>
          </button>
        </div>
      </div> -->

      <!-- <button v-else @click="statusEmail(true)">
        <ion-icon name="mail-outline"></ion-icon>
        Enviar por e-mail
      </button> -->

      <button @click="closeModal">
        Fechar
      </button>
    </confirmation-modal>
  </section>
</template>

<script>

import shadowBox from '../../components/layouts/shadowBox.vue'
import LeftMenu from '../../components/leftMenu.vue'
import {
  GET_POINT_VOUCHER,
  SHARE_INFO,
  GET_POINT_VOUCHER_EMAIL,
  WORKING_LOCAL_EMPLOYEE_TODAY,
  DOWNLOAD_VAUCHER
} from "../../../../urlConfig";
import {REQUEST_SERVICE} from "../../../../requestConfig";
import {UTIL_SERVICE} from "../../../../utils";
import confirmationModal from '../../components/confirmationModal.vue';
import generalHeader from '../../components/layouts/generalHeader.vue';
import dotLoader from '../../components/dotLoader.vue';

export default {
  name: 'newConfirmPoint',
  components: { shadowBox, LeftMenu, confirmationModal, generalHeader,dotLoader },
  data() {
    return {
      captures: "",
      stream: "",
      dataWebCam: "",
      video: {},
      canvas: {},
      turnSelected: 0,
      validateInputEmail: false,
      valueEmail: '',
      loadingEmail: false,
      sendEmailDisplay: false,
      viewMoreSign: false,
      isVoucherModalOpened: false,
      pointDayIdLast: null,
      dataCodeVaucher: {
        viewMore: false,
      },
      newPointRegister: 0,
      countModal: true,
      loadingVoucher: false,
      dataPointRegister: {
        dataConfirm: {
          id: null,
          date: null
        }
      },
    }
  },
  beforeMount() {
      try {
        const dataConfigProgressPoint = UTIL_SERVICE.getStorage('configProgressPoint');
        if (dataConfigProgressPoint.newPointRegister) {
          this.newPointRegister = dataConfigProgressPoint.newPointRegister;
        }
      } catch (e) {}

      try {
        this.pointDayIdLast = UTIL_SERVICE.getStorage('pointDayIdLast').id;
      } catch (e) {}

      if (JSON.parse(window.localStorage.getItem('dataConfirmPoint')))
        this.dataPointRegister = JSON.parse(window.localStorage.getItem('dataConfirmPoint'));

      if (!this.dataPointRegister.dataConfirm.id || !this.dataPointRegister.dataConfirm.date) {
        this.$router.push({path: '/'});
      }
  },
  methods: {
    redirectToHome() {
      this.$router.push('/')
    },
    setTurnSelected(value) {
      this.turnSelected = value;
    },
    closeModal() {
      this.sendEmailDisplay = false;
      this.valueEmail = '';
      this.isVoucherModalOpened = false;

      // $('#modalPointVaucher').modal('hide');
    },
    sendEmail() {
      if(this.valueEmail === '') {
        return this.validateInputEmail = true
      }

      const validateEmail = function (value) {
        const regex =  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(value);
      }

      if (!validateEmail(this.valueEmail)) {
        this.$toast.error("Não foi possível enviar para este e-mail, Parece que esse é um e-mail inválido, digite outro e-mail e tente novamente.")
      }

      this.loadingEmail = true;

      let idDay = ''

      if(this.idDay) {
        idDay = this.idDay;
      }

      REQUEST_SERVICE.get(GET_POINT_VOUCHER_EMAIL + idDay + '?email=' + this.valueEmail)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_POINT_VOUCHER_EMAIL:", response.data);

          if(response.data.emailsucess) {
            this.closeModal();

            this.$toast.success("E-mail enviado com sucesso!")

            // swal({
            //   title: "Sucesso!",
            //   text: "E-mail enviado com sucesso!",
            //   icon: "success",
            // });
          } else {
            this.$toast.error("Parece que esse é um e-mail inválido, digite outro e-mail e tente novamente.")
            // swal({
            //   title: "Não foi possível enviar para este e-mail",
            //   text: "Parece que esse é um e-mail inválido, digite outro e-mail e tente novamente.",
            //   icon: "warning",
            //   button: "Entendi!",
            // });
          }

          this.loadingEmail = false;

        }).catch(reason => {
          this.loadingEmail = false;
          console.log('oi')
          reason.response.data.erros.map((value, index) => {
            // swal("Aviso", value.value, "error");
            this.$toast.error(value.value)
          });
          this.$toast.error(reason.data)
          UTIL_SERVICE.console("RESULT ERROR:", reason.data);
      });
    },
    statusEmail(value) {
      this.sendEmailDisplay = value;
    },
    viewMoreLess(data) {
      data.viewMore = !data.viewMore
    },
    viewMoreLessSign(value) {
      this.viewMoreSign = value;
    },
    openModalVoucher() {
      const companyId = this.$route.params.userInfo.companyId;
      const permissionVoucher = companyId === '691684062F204A17A2C20D40B88E101B' || companyId === '5CF2DAA543094160A1B90F5F28201882';
      this.loadingVoucher = true;
      if (this.countModal) {
        if (permissionVoucher) {
          REQUEST_SERVICE.get(DOWNLOAD_VAUCHER).then((response) => {
            UTIL_SERVICE.console("RESULT GET_POINT_VOUCHER:", response.data);
            window.open(response.data, '_blank');
            this.loadingVoucher = false;
          }).catch(reason => {
            this.loadingVoucher = false;
            UTIL_SERVICE.console("RESULT ERROR:", reason.response.data);
          });
        } else {
          if(!this.isVoucherModalOpened) {
            this.isVoucherModalOpened = true;
            $('#modalPointVaucher').modal();
            this.loadingVoucher = false;
          }
        }
      }
    },
  }
}
</script>

<style scoped lang="scss">

.return-home-button {
  border-radius: 20px;
  border: 1px solid var(--darkBlue);
  background: var(--darkBlue);
  display: flex;
  width: 160px;
  height: 41px;
  padding: 8px 12px;
  align-items: center;
  gap: 10px;
  color: #ffffff;
  position: absolute;
  left: 50%;
  top: 93%;
  transform: translate(-50%, -95%);
  cursor: pointer;

  ion-icon {
    width: 18px;
    height: 18px;
  }
}

#mainContent {
  background-image: url('../../../../assets/img/bg-register-point.png');
}

.register-loader:hover {
  background: var(--leftMenuColor) !important;
}

#voucher-modal {
  button {
    border-radius: 20px;
    border: 1px solid var(--darkBlue);
    background: var(--darkBlue);
    display: inline-flex;
    justify-content: center;
    width: 97px;
    height: 34px;
    padding: 8px 12px;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    color: #fff;
    font-weight: 600;

    ion-icon {
      width: 18px;
      height: 18px;
      color: #fff
    }
  }
}
.hide-code {
  display: list-item;
  width: 70%;
  white-space: nowrap;
  overflow: hidden!important;
  text-overflow: ellipsis;
}

.confirm-point-wrapper {
  position: relative;
  height: 80vh;
  width: 75vw;
}
.confirm-point {
  position: absolute;
  left: 50%;
  top: 30%;
  display: flex;
  padding: 27px 45px;
  flex-direction: column;
  align-items: center;
  gap: 27px;
  height: 425px;
  width: 450px;
  transform: translate(-50%, -30%);

  #voucher-loader {
    top: -12%;
    left: -7%;
    position: absolute;
  }

  #voucher-loader:hover {
    color: #fff !important;
  }


  ion-icon {
    width: 94px;
    height: 94px;
    color: #2AC166;
  }

  span {
    text-align: center;
    color: var(--text);
    font-size: 12px;
    max-width: 312px;
  }

  #confirm-point-date {
    color: #2AC166;
    text-align: center;
    font-size: 20px;
    max-width: 22ch;
  }

  button {
    position: relative;
    transition: 0.5s;
    min-height: 33px;
    padding: 6px;
    width: 202px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    color: var(--blueText);
    font-size: 16px;
    font-weight: 600;
    border-radius: 24.651px;
    border: 1px solid var(--border);
    background: var(--leftMenuColor);
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.10), 1.23256px 1.23256px 4.93023px 0px rgba(0, 0, 0, 0.10), 4.93023px 7.39535px 8.62791px 0px rgba(0, 0, 0, 0.09), 9.86046px 16.02325px 11.09302px 0px rgba(0, 0, 0, 0.05), 18.48837px 28.34883px 13.55814px 0px rgba(0, 0, 0, 0.01), 28.34883px 43.13953px 14.7907px 0px rgba(0, 0, 0, 0.00);



    .open-voucher-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;

      ion-icon{
        transition: 0.5s;
        width: 20px;
        height: 20px;
        color: var(--darkBlue);
      }

      span {
        text-align: center;
        color: var(--darkBlue);
        font-size: 16px;
        max-width: 312px;
      }
    }
  }
}

.print-background-wrapper {
  position: relative;
  height: vh;
  z-index: -1;
  overflow: hidden;

  #first-bg {
    position: absolute;
    top: -310px;
    left: -377px;
    transform: scale(0.7);
  }

  #second-bg {
    position: absolute;
    left: 56%;
    top: -16%;
    transform: rotate(36deg);
  }

  .hide-code {
    display: list-item;
    width: 70%;
    white-space: nowrap;
    overflow: hidden!important;
    text-overflow: ellipsis;
  }

  .modal-body {
    margin-top: 16px;
    padding: 16px;
    background: #FFF0B4;
    position: relative;

    .voucher-heade {
      display: flex;
      flex-direction: column;
      align-items: center;

      font-size: 17px;
      font-weight: 400;
      line-height: 23.91px;
      color: #191919;

      .header-date {
        font-weight: 700;
        margin-bottom: 16px;
      }
    }

    .body-content {
      margin-top: 26px;
      padding-top: 18px;
      border-top: 1px dashed #191919;
      border-bottom: 1px dashed #191919;
      margin-bottom: 18px;
      overflow: auto;
      height: 70px;
      overflow: auto;

      ion-icon {
        width: 82px;
        height: 82px;
      }

      .content-points {
        display: flex;
        flex-direction: column;
        word-break: break-all;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 18px;
        }

        .point-title {
          font-size: 14px;
          font-weight: 400;
          line-height: 19.69px;

          span {
            font-size: 14px;
            font-weight: 700;
          }
        }

        .point-code {
          display: flex;

          span {
            margin-left: 3px;
          }

          .more-less {
            color: var(--textActiveSide);
            cursor: pointer;
            font-size: 10px;
            font-weight: 400;
            line-height: 14.06px;
            margin: 0;

            &:hover {
              text-decoration: underline;
            }
          }
        }

        span {
          color: #191919;
          font-size: 10px;
          font-weight: 400;
          line-height: 14.06px;
        }
      }
    }

    .footer-body {
      position: absolute;
      bottom: -21px;
      left: 0px;
      width: 100%;

      svg {
        path {
          fill: #FFF0B4;
          opacity: 1;
        }
      }
    }
  }
}

.voucher-modal-body {
  padding: 16px;
  background: #FFF0B4;
  position: relative;
  width: 327px;
  margin-bottom: 23px;

  .footer-body {
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 100%;
    border-top: 1px solid #FFF0B4;

    svg {
      path {
        fill: #FFF0B4;
        opacity: 1;
      }
    }
  }
  .body-signature {
    display: flex;
    flex-direction: column;
    word-break: break-all;

    .signature-title {
      font-size: 10px;
      font-weight: 400;
      line-height: 14.06px;
      color: #191919;
    }

    .signature-id {
      font-size: 10px;
      font-weight: 400;
      line-height: 14.06px;
      color: #191919;
      margin-bottom: 8px;

      .more-less {
        color: var(--textActiveSide);
        cursor: pointer;
        font-size: 10px;
        font-weight: 400;
        line-height: 14.06px;
        margin: 0 0 0 6px;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .signature-reference {
      font-size: 14px;
      font-weight: 400;
      line-height: 19.69px;
      color: #191919;

      span {
        font-size: 14px;
        font-weight: 700;
      }
    }
  }

  .voucher-header {
    display: flex;
    flex-direction: column;
    align-items: center;

    font-size: 17px;
    font-weight: 400;
    color: #3A424E;

    .header-date {
      font-weight: 700;
      margin-bottom: 16px;
    }

    span:nth-child(2) {
      font-weight: 600;
    }
  }

  .body-content {
    padding-top: 18px;
    margin-bottom: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ion-icon {
      width: 82px;
      height: 82px;
    }


    &::-webkit-scrollbar {
      width: 6px;
      position: absolute;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #D5DFEB;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #3A424E;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #3A424E;
      transition: .5s;
    }

    .content-points {
      display: flex;
      flex-direction: column;
      word-break: break-all;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 18px;
      }

      .point-title {
        font-size: 14px;
        font-weight: 400;
        line-height: 19.69px;

        span {
          font-size: 14px;
          font-weight: 700;
        }
      }

      .point-code {
        display: flex;

        span {
          margin-left: 3px;
        }

        .more-less {
          color: var(--textActiveSide);
          cursor: pointer;
          font-size: 10px;
          font-weight: 400;
          line-height: 14.06px;
          margin: 0;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      span {
        color: #191919;
        font-size: 10px;
        font-weight: 400;
        line-height: 14.06px;
      }
    }
  }

  .body-collaborator {
    display: flex;
    flex-direction: column;
    word-break: break-all;
    border-bottom: 1px dashed #191919;
    margin-bottom: 10px;
    padding-bottom: 18px;

    .collaborator-name {
      font-size: 14px;
      font-weight: 400;
      line-height: 19.69px;
      color: #191919;

      span {
        font-size: 14px;
        font-weight: 700;
      }
    }

    span {
      font-weight: 700;
      font-size: 14px;
    }
  }

}

.body-email {
  width: 327px;
  .email-input {
    position: relative;
    margin-bottom: 40px;

    label {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      color: var(--defaultText);
      background-color: var(--leftMenuColor);
      width: 50%;
      position: absolute;
      top: -13px;
      left: 14px;

      span {
        color: var(--redColor);
      }
    }

    input {
      display: inline-flex;
      height: 36px;
      padding: 6px 44.5px 6px 12px;
      align-items: center;
      flex-shrink: 0;
      border-radius: 10px;
      border: 1px solid var(--border);
      background: var(--leftMenuColor) !important;
      width: 100%;

      &::placeholder {
        color: var(--textSide);
      }
    }

    .validate-input {
      position: absolute;
      left: 9px;
      top: 33px;
      font-size: 12px;
      font-weight: 400;
      color: var(--redColor);
    }
  }

  .email-btn {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;

    .btn-cancel {
      display: flex;
      padding: 8px 32px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 20px;
      border: 1px solid var(--border);
      font-weight: 600;
      color: var(--defaultText);

      &:hover {
        cursor: pointer;
      }
    }

    .btn-send {
      background: var(--darkBlue);
      display: flex;
      width: 128px;
      padding: 8px 32px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      border-radius: 20px;
      border: 1px solid var(--darkBlue);

      &:hover {
        cursor: pointer;
      }

      .btn-group {
        display: flex;
        align-items: center;

        svg {
          margin-right: 6px;

          path {
            color: #FFFFFF;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/confirmPoint/newConfirmPoint.vue